import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { StyledUtils } from '@ocean/utils'
import { navControlStyles, activeNavControlStyles } from 'components/navigation/common/styles'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: ${theme.space.desktop.base};
  `}
`

export const ViewButtonGroup = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
  flex-shrink: 0;

  ${({ theme }) => `
    border-radius: ${theme.borderRadius.base};
  `}

  ${({ theme }) => media.sm`
    margin-left: ${theme.space.desktop.small};
  `}
`

type ViewButtonProps = {
  isActive: boolean
}

export const ViewButton = styled.button<ViewButtonProps>`
  ${StyledUtils.clearButton}
  ${navControlStyles}

  ${({ theme }) => `
    padding: 0 ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    padding: 0 ${theme.space.desktop.base};
  `}

  ${({ isActive }) => isActive && activeNavControlStyles}
`

export const Label = styled.div`
  flex: 1 0;

  ${({ theme }) => `
    font-family: ${theme.fontFamily.secondary};
    font-size: ${theme.fontSize.desktop.base};
    line-height: ${theme.lineHeight.desktop.base};
    font-weight: ${theme.fontWeight.normal};
    padding: ${theme.space.mobile.small} 0;
  `}

  ${media.sm`
    padding: 0;
  `}
`

export const NavigationButtonGroup = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-shrink: 0;

  button + button {
    margin-left: 3px;
  }

  ${({ theme }) => media.sm`
    margin-right: ${theme.space.desktop.small};
  `}
`

export const NavigationButton = styled.button`
  ${StyledUtils.clearButton}
  display: flex;
  height: 40px;
  width: 40px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;

  ${({ theme }) => `
    border: 1px solid ${theme.color.cornflower};
    border-radius: ${theme.borderRadius.base};
    font-family: ${theme.fontFamily.primary};
    font-size: ${theme.fontSize.mobile.base};
    font-weight: ${theme.fontWeight.bold};
    color: ${theme.color.ocean};

    svg {
      width: 16px;
      
      path {
        stroke: ${theme.color.ocean};
      }
    }

    &:hover, &:focus {
      border: 1px solid ${theme.color.ocean};
    }
  `}

  ${({ theme }) => media.sm`
    height: 50px;
    width: 50px;
    font-size: ${theme.fontSize.desktop.h2};

    svg {
      width: 20px;
    }
  `}
`

export const TodayDot = styled.span`
  width: 15px;
  height: 15px;
  border-radius: 50%;

  ${({ theme }) => `
    background: ${theme.color.ocean};
  `}
`
